export const nudgeCooldownTimeSeconds = 24 * 60 * 60;
